import { INTERNAL_DOCUMENT_TYPE } from 'features/internal-document/common/types';
import { WORK_TYPE } from 'features/work/types';
import { createElement, ReactNode } from 'react';
import { lazyImport } from 'routes/helpers';
import { getPath } from 'routes/router-paths';
import {
  DOCUMENT_MANAGEMENT_TYPE,
  SYSTEM_CATEGORY_TAB,
  WORK_SCHEDULE_URL,
} from 'routes/types';

export type TBreadcrumb = {
  title: string;
  path?: string;
};

export type TRoute = {
  path: string;
  element: ReactNode;
  permissionKeys?: string[];
  pageHeader?: string;
  breadcrumbs?: TBreadcrumb[];
};

export type TPageInfo = {
  pageTitle: string;
};

export const publicRoutes: TRoute[] = [
  {
    path: getPath('loginPage'),
    element: createElement(
      lazyImport(() => import('modules/Authentication/LoginPage')),
      { pageTitle: 'Đăng nhập' }
    ),
  },
  {
    path: getPath('forbiddenPage'),
    element: createElement(
      lazyImport(() => import('components/ForbiddenAccessNotice'))
    ),
  },
];

export const privateRoutes: TRoute[] = [
  {
    path: getPath('dashboardPage'),
    element: createElement(
      lazyImport(() => import('modules/Miscellaneous/DashboardPage')),
      { pageTitle: 'Trang chủ' }
    ),
  },

  /** Calendar module */
  {
    path: getPath(
      'workSchedulePage',
      ':pageType' as WORK_SCHEDULE_URL.WORK_SCHEDULE
    ),
    element: createElement(
      lazyImport(
        () => import('modules/WorkSchedule/WorkSchedulePage/WorkSchedulePage')
      )
    ),
  },
  {
    path: getPath('workSchedulePermissionPage'),
    element: createElement(
      lazyImport(
        () => import('modules/WorkSchedule/WorkSchedulePermissionPage')
      )
    ),
  },
  {
    path: getPath('workScheduleCreate'),
    element: createElement(
      lazyImport(
        () =>
          import(
            'features/work-schedule/components/WorkSchedulePageActions/WorkScheduleCreate'
          )
      )
    ),
  },
  {
    path: getPath('workScheduleDetail', ':workScheduleId'),
    element: createElement(
      lazyImport(
        () =>
          import(
            'features/work-schedule/components/WorkSchedulePageActions/WorkScheduleDetail'
          )
      )
    ),
  },
  {
    path: getPath('workScheduleUpdate', ':workScheduleId'),
    element: createElement(
      lazyImport(
        () =>
          import(
            'features/work-schedule/components/WorkSchedulePageActions/WorkScheduleUpdate'
          )
      )
    ),
  },

  /** Document module */
  {
    path: getPath(
      'internalDocumentsListPage',
      ':pageType' as INTERNAL_DOCUMENT_TYPE
    ),
    element: createElement(
      lazyImport(() => import('modules/Documents/InternalDocumentsListPage'))
    ),
  },
  {
    path: getPath(
      'internalDocumentDetailPage',
      ':pageType' as INTERNAL_DOCUMENT_TYPE,
      ':documentCode'
    ),
    element: createElement(
      lazyImport(() => import('modules/Documents/InternalDocumentDetailPage'))
    ),
  },
  {
    path: getPath(
      'connectedDocumentsPage',
      ':pageType' as INTERNAL_DOCUMENT_TYPE
    ),
    element: null,
  },
  {
    path: getPath(
      'connectedCommitteeDocumentsPage',
      ':pageType' as INTERNAL_DOCUMENT_TYPE
    ),
    element: null,
  },
  {
    path: getPath(
      'documentsManagement',
      ':managementType' as DOCUMENT_MANAGEMENT_TYPE
    ),
    element: null,
  },
  {
    path: getPath('documentMangagementPermission'),
    element: createElement(
      lazyImport(
        () => import('modules/Documents/DocumentManagement/DocumentManagement')
      )
    ),
  },

  /** Work module */
  {
    path: getPath('workListPage', ':workType' as WORK_TYPE),
    element: createElement(
      lazyImport(() => import('modules/Work/WorkListPage'))
    ),
  },
  {
    path: getPath('workDetailPage', ':workCode'),
    element: createElement(
      lazyImport(() => import('modules/Work/WorkDetailPage'))
    ),
  },

  /** Mission module */
  {
    path: getPath('missionManagementPermission'),
    element: createElement(
      lazyImport(() => import('modules/Mission/MissionManagement'))
    ),
  },

  /** Salary module */
  {
    path: getPath('salaryManageMentPermission'),
    element: createElement(
      lazyImport(() => import('modules/Salary/SalaryManagement'))
    ),
  },

  /** Proposal module */
  {
    path: getPath('proposalManagementPermission'),
    element: createElement(
      lazyImport(() => import('modules/Proposal/ProposalManagement'))
    ),
  },

  /** Risk module */
  {
    path: getPath('riskManagementPermission'),
    element: createElement(
      lazyImport(() => import('modules/Risk/RiskManagement'))
    ),
  },

  /** Ultities module */
  {
    path: getPath('ultilityManagementPermission'),
    element: createElement(
      lazyImport(() => import('modules/Ultilities/UltilityManagement'))
    ),
  },
  {
    path: getPath('contactPage'),
    element: createElement(
      lazyImport(() => import('modules/Ultilities/Contact/ContactPage'))
    ),
  },

  /** Management module */
  {
    path: getPath('moduleManagementPage'),
    element: createElement(
      lazyImport(() => import('modules/Management/Module/ModuleManagementPage'))
    ),
  },
  {
    path: getPath('systemCategoryPage', ':pageType' as SYSTEM_CATEGORY_TAB),
    element: createElement(
      lazyImport(
        () => import('modules/Management/SystemCategory/SystemCategoryPage')
      )
    ),
  },
  {
    path: getPath('accountManagementPage'),
    element: createElement(
      lazyImport(() => import('modules/Management/Account'))
    ),
  },
  {
    path: getPath('managementPermission'),
    element: createElement(
      lazyImport(() => import('modules/Management/ManagementPermission'))
    ),
  },

  /** Report module */
  {
    path: getPath('reportPage'),
    element: createElement(
      lazyImport(() => import('modules/Report/ReportPage'))
    ),
  },
];
